import React from 'react';
import Loading from './Loading';
import Table from './table';
import {connect} from 'react-redux'; 
import mapStateToProps from '../store/mapState'

function Records({prep,add,setAdd,setStyle,color,dispatch}){
    const server = 'grishin.tech/backend';
    const [value,setValue] = React.useState();
    const [rec,setRec] = React.useState();
    React.useEffect(() =>{
      fetch(`https://${server}/getrecords`)
      .then(response => response.json())
      .then(response => {
        setRec(response)
      })
    },[])

    function addRecord(title,scr){
        let data = {name: title,score:scr};
        fetch(`https://${server}/addrecord`,{
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
          },
          body: JSON.stringify(data)
        }
        )
        .then(response => response.json())
        .then(response => {
          setRec(response)
        })
      }
    
    return(
    <div className='GameP' style={{color: color}}>
        <h1 style={{marginBottom: '1em'}}>Список рекордов</h1>
        {rec ? <Table color={color} add={add} rec={rec} setValue={setValue} value={value}/>:<Loading color={color}/>}
        {add === 0 ? 
            <button className = 'btn' style={{margin: '1em', color: 'blue'}} onClick={()=>{setStyle('fixed'); dispatch({type: 'init'});}}>Назад</button>:<button className = 'btn' style={{margin: '1em', color: 'blue'}} onClick={()=>{addRecord(value,add); setAdd(0);}}>Добавить</button>}
    </div>
    )
}

export default connect(mapStateToProps)(Records);